import { ACCESS } from "@dictybase/auth-mui5"
import { NotFoundError } from "@dictybase/ui-common"

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default NotFoundError
export const access = ACCESS.public
